import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { MapPasswordPrompt, MapPasswordService } from './map-password.service';

/**
 * Modal único de senha de mapa/log, hospedado no shell (DashboardTemplateComponent) e dirigido
 * pelo `MapPasswordService.prompt$`. Não conhece quem pediu a leitura: só devolve a senha
 * digitada (ou o cancelamento) ao serviço, que repete a requisição.
 *
 * A senha é limpa do componente assim que é entregue ao serviço — nunca fica em memória
 * além do necessário, nem vai para storage.
 */
@Component({
  selector: 'app-map-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, TranslocoRootModule],
  templateUrl: './map-password-modal.component.html',
  styleUrl: './map-password-modal.component.css',
})
export class MapPasswordModalComponent implements OnInit, OnDestroy {
  @ViewChild('passwordInput') passwordInput?: ElementRef<HTMLInputElement>;

  prompt: MapPasswordPrompt | null = null;
  password = '';

  private subscription?: Subscription;

  constructor(private passwordService: MapPasswordService) {}

  ngOnInit(): void {
    this.subscription = this.passwordService.prompt$.subscribe((prompt) => {
      this.prompt = prompt;
      if (!prompt) this.password = '';
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  /** `.ftm`/`.ftml` pedem a senha de PREPARADOR do PowerFT; `.ftmap`/`.ftlog` a senha do VisionFT. */
  get isPowerFt(): boolean {
    return this.prompt?.fileType === 'ftm' || this.prompt?.fileType === 'ftml';
  }

  get busy(): boolean {
    return this.prompt?.busy === true;
  }

  get canSubmit(): boolean {
    return !this.busy && this.password.length > 0;
  }

  focusInput(): void {
    this.passwordInput?.nativeElement.focus();
  }

  submit(): void {
    if (!this.canSubmit) return;
    // Sem trim: espaços fazem parte da senha (contrato §3).
    const password = this.password;
    this.password = '';
    this.passwordService.submit(password);
  }

  cancel(): void {
    if (this.busy) return;
    this.password = '';
    this.passwordService.cancel();
  }
}
